import { toast } from "react-toastify";
import SelectCustomers from "components/ui/selectors/SelectCustomers";
import { useBill } from "hooks/bill";

export default function CaseDiversionModal() {
  const { 
    selectBoxes,
    updateSelectBox,
    handleCaseDiversionConfirm, 
    setShowCaseDiversionModal,
    resetCaseDiversionModal,
  } = useBill();

  const handleConfirm = () => {
    if (!selectBoxes.transferCustomer) {
      toast.error("Please select a customer to transfer to");
      return;
    }

    // Pass the customer object directly
    handleCaseDiversionConfirm(selectBoxes.transferCustomer);
    setShowCaseDiversionModal(false);
  };

  return (
    <div>
      <div className="space-y-8">
        <div className="border-b border-gray-900/10 pb-10">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Case Diversion - Transfer Packing List
          </h2>
          
          {selectBoxes.customer && (
            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
              <p className="text-sm text-blue-800">
                <span className="font-semibold">Current Customer:</span> {selectBoxes.customer.name}
              </p>
              <p className="text-xs text-blue-600 mt-1">
                This packing list will be transferred to the selected customer below
              </p>
            </div>
          )}

          <div className="mt-8 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="col-span-full">
              <SelectCustomers
                label="Transfer to Customer *"
                value={selectBoxes.transferCustomer}
                onChange={(value) => updateSelectBox("transferCustomer", value)}
                isClearable={false}
              />
              <p className="mt-2 text-sm text-gray-500">
                The bill type will change from PL to STK (Stock) after transfer.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          type="button"
          className="text-sm font-semibold rounded-md px-3 py-2 hover:bg-gray-100 text-gray-900"
          onClick={() => {
            resetCaseDiversionModal(); // Clear the form when cancelling
            setShowCaseDiversionModal(false);
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          className="rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Confirm Transfer
        </button>
      </div>
    </div>
  );
}
